module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.9f214421.woff";